import { render, staticRenderFns } from "./legal-settle-case-manage.vue?vue&type=template&id=faaea768&scoped=true"
import script from "./legal-settle-case-manage.vue?vue&type=script&lang=ts"
export * from "./legal-settle-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faaea768",
  null
  
)

export default component.exports